import React from 'react';
import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from 'mobx-state-tree';

import { utils } from 'lib';

const initState = {};

export const Model = types
  .model({})
  .volatile((self) => {
    return {
      modals: [],
    };
  })
  .actions((self) => {
    const add = (key, Com) => {
      // console.log('add modal', key, Com)
      remove(key);
      self.modals = [
        ...self.modals,
        {
          key,
          Com,
        },
      ];
    };
    const remove = (key) => {
      if (self.modals.findIndex((item) => item.key === key) > -1) {
        self.modals = self.modals.filter((item) => {
          return item.key !== key;
        });
      }
    };
    const clear = () => {
      self.modals = [];
    };
    return {
      add,
      remove,
      clear,
    };
  });

export default {
  initState,
  Model,
};
